import { createApiClient } from "@kquant/core";
import { API_BASE } from "../config";
import { useAuthStore } from "../store/auth";

// Типизированный клиент-синглтон. getToken/onUnauthorized читают auth-store в момент вызова (без циклов импорта значений).
// onUnauthorized: 401 на не-/api/auth/* → сброс сессии → App покажет экран входа (порт showAuth из app-core.js).
export const api = createApiClient({
  baseUrl: API_BASE,
  getToken: () => useAuthStore.getState().token,
  onUnauthorized: () => useAuthStore.getState().clearSession(),
});

// Клиент для НЕОБЯЗАТЕЛЬНЫХ эндпоинтов (порт legacy opts.optional): его 401 НЕ разлогинивает —
// иначе один 401/403 на фича-эндпоинте (cross-каталог) выбил бы валидную сессию.
export const apiOptional = createApiClient({
  baseUrl: API_BASE,
  getToken: () => useAuthStore.getState().token,
});
